import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Login from '@/components/steps/Login.vue';
import Start from '@/components/steps/NewAccount.vue';
import PersonalData from '@/components/steps/PersonalData.vue';
import ConfirmPhone from './components/steps/ConfirmPhone.vue';
import AddressDetails from '@/components/steps/AddressDetails.vue';
import TaxResidence from '@/components/steps/TaxResidence.vue';
import Currency from '@/components/steps/Currency.vue';
import DeclarationAcceptance from '@/components/steps/DeclarationAcceptance.vue';
import RiskAssessment from '@/components/steps/RiskAssessment.vue';
import ClientZoneLogin from '@/components/steps/ClientZoneLogin.vue';
import store from './store';
import { UtilityHelper } from '@/helpers/UtilityHelper';
import ConfirmEmail from '@/components/steps/ConfirmEmail.vue';
import UploadDocumentFront from '@/components/steps/UploadDocumentFront.vue';
import UploadFailed from './components/steps/UploadFailed.vue';
import UploadSucceeded from './components/steps/UploadSucceeded.vue';
import WaitingForPicture from './components/steps/WaitingForPicture.vue';
import HowToTakePicture from './components/steps/HowToTakePicture.vue';
import ReturnToDesktop from './components/steps/ReturnToDesktop.vue';
import PhoneNumber from './components/steps/PhoneNumber.vue';
import OnboardingDenied from './components/steps/OnboardingDenied.vue';
import ThxPageAccountOpen from '@/components/steps/AccountOpen.vue';
import UploadException from './components/steps/UploadException.vue';
import {
    amplitudeSendEvent,
    AnalyticsEvent,
    routeAnalyticsEvents,
} from './utils/AmplitudeAnalyticsEvents';
import AnalyticsHelper from './helpers/AnalyticsHelper';
import AccountType from './components/steps/AccountType.vue';
import EsgSubmit from './components/steps/EsgSubmit.vue';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/login',
        name: 'restart',
        component: Login,
    },
    {
        path: '/login',
        name: 'newLogin',
        component: Login,
    },
    {
        path: '/',
        name: 'newAccount',
        component: Start,
    },

    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: Start,
    },

    {
        path: '/personal-data',
        name: 'personalDataConfirm',
        component: PersonalData,
    },
    {
        path: '/confirm-phone',
        name: 'desktopSms',
        component: ConfirmPhone,
    },

    // -----------------------------------------------------------------------------------------------------

    {
        path: '/how-to-take-picture',
        name: 'howToTakePicture',
        component: HowToTakePicture,
    },
    {
        path: '/upload-document',
        name: 'desktopDocumentUpload',
        component: UploadDocumentFront,
    },
    {
        path: '/upload-failed',
        name: 'uploadFailed',
        component: UploadFailed,
    },
    {
        path: '/upload-exception',
        name: 'uploadException',
        component: UploadException,
    },
    {
        path: '/upload-succeeded',
        name: 'uploadSucceeded',
        component: UploadSucceeded,
    },
    {
        path: '/phone-number',
        name: 'mobileSms',
        component: PhoneNumber,
    },
    {
        path: '/confirm-email',
        name: 'confirmEmail',
        component: ConfirmEmail,
    },
    {
        path: '/waiting-for-mobile',
        name: 'mobileDesktopIsCompleted',
        component: WaitingForPicture,
    }, // Mobile route started, desktop waits until mobile is completed

    // // ---------------------------------------------------
    // // <editor-fold desc="ON MOBILE PHONE (MOBILE ROUTE)">
    // // ---------------------------------------------------
    {
        path: '/upload-document',
        name: 'mobileDocumentUpload',
        component: UploadDocumentFront,
    },
    {
        path: '/return-to-desktop',
        name: 'mobileReturnToDesktop',
        component: ReturnToDesktop,
    },

    // -----------------------------------------------------------------------------------------------------

    {
        path: '/residence-details',
        name: 'addressDetails',
        component: AddressDetails,
    },

    {
        path: '/account-type',
        name: 'chooseAccountType',
        component: AccountType,
    },

    {
        path: '/tax-residence',
        name: 'taxOfficeDetails',
        component: TaxResidence,
    },

    {
        path: '/currency',
        name: 'currencyChoice',
        component: Currency,
    },
    {
        path: '/declaration-acceptance',
        name: 'declarationAcceptance',
        component: DeclarationAcceptance,
    },
    {
        path: '/esg-submit',
        name: 'esgSubmit',
        component: EsgSubmit,
    },
    {
        path: '/risk-assessment',
        name: 'riskAssessment',
        component: RiskAssessment,
    },

    // -----------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------

    {
        path: '/client-zone-login',
        name: 'errorsReport',
        component: ClientZoneLogin,
    },
    {
        path: '/denied',
        name: 'onboardingDenied',
        component: OnboardingDenied,
    },
    {
        path: '/account-open',
        name: 'accountOpen',
        component: ThxPageAccountOpen,
    },
];

const router = createRouter({
    history: createWebHistory(UtilityHelper.getBaseByLocale()),
    routes,
});

router.afterEach(async (to) => {
    const step = to.name as string;
    store.commit('SET_ROUTE', step);

    await Promise.resolve();
    const interval = setInterval(() => {
        if (store.state.isLocked === false) {
            window.scrollTo(0, 0);
            clearInterval(interval);
        }
    }, 50);

    await AnalyticsHelper.sendStepEventOnce(step);
});

router.afterEach((to) => {
    const routeName = to.name?.toString();
    const eventName = routeAnalyticsEvents[routeName || ''];

    setTimeout(() => {
        if (eventName) {
            amplitudeSendEvent(eventName as AnalyticsEvent);
        }
    }, 500);
});

export default router;
